export const transitionProps = {
  delay: {
    type: Number,
    required: false,
    default: 0,
  },
  maxDelay: {
    type: Number,
    required: false,
    default: 1.5,
  },
  duration: {
    type: Number,
    required: false,
    default: 0.35,
  },
  enabled: {
    type: Boolean,
    required: false,
    default: true,
  },
  animateExit: {
    type: Boolean,
    required: false,
    default: false,
  },
  animateAppear: {
    type: Boolean,
    required: false,
    default: false,
  },
}
